import { createThemeCompiler } from '../../../utils';

export const badgeThemeCompiler = createThemeCompiler(({ palette, borderRadius }) => ({
    badge: {
        colors: {
            backgroundColor: palette.themeLighterAlt,
            foregroundColor: palette.themeDark
        },
        composites: {
            borderRadius: borderRadius.curvedXLarge
        }
    }
}));
